<template>
  <div class="area P3">
    <div class="d d_gl">
      <s-header :name="'感谢您参与少先队组织信息数据系统您需填写的项目有'" :type="2"></s-header>
      <!-- <div v-if="roleId == 8" class="video-jiangjie" @click="playVideo()">学校填报教学视频</div> -->
      <van-pull-refresh class="order-list-refresh">
        <van-list v-if="list.length > 0" v-model:loading="loading" @load="onLoad" :finished="finished">
          <info-item :list="list" :type="1"></info-item>
        </van-list>
        <van-empty v-else description="暂无相关数据" />
      </van-pull-refresh>
    </div>
    <nav-bar />

  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useStore } from "vuex";
import navBar from "@/components/NavBar";
import sHeader from "@/components/SimpleHeader";
import { listForm } from "@/service/form";
import { getCurrentInfo } from "@/service/user";
import { Toast } from "vant";
import { getLocal, getRoleId } from "@/common/js";
import infoItem from "@/components/FormItem";
export default {
  name: "xtj",
  components: {
    navBar,
    sHeader,
    infoItem,
  },
  setup() {
    const store = useStore();
    const state = reactive({
      list: [],
      loading: true,
      finished: false,
      roleId: null
    });

    onMounted(async () => {
      const r = await getRoleId();
      if(r) {
        state.roleId = r
      }
      userInfo();
      loadData();
      
    });
    // 获取当前用户的身份信息
    const userInfo = async () => {
      const { data, code } = await getCurrentInfo();
      if (code === 10000) {
        const { roleList, city, district, province, provinceCode, cityCode, districtCode,  } = data;
        store.commit("info/SET_ROLELIST", roleList);
        store.commit("info/SET_AREA", { province, city, district, provinceCode, cityCode, districtCode });
      }
    };

    const onLoad = () => {
      // loadData();
    };
    const loadData = async () => {
      const token = getLocal("dsj_accessToken");
      if (token) {
        state.isLogin = true;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      // 获取可填报的列表
      const { code, data } = await listForm({status: -1});
      console.log('data-->', data)
      if (code === 10000) {
        if (data && data.length > 0) {
          state.list = state.list.concat(data);
        }
        state.finished = true;
        state.loading = false;
      }
       Toast.clear();
    };
    const playVideo = () => {
      window.location.href = "https://weibo.com/2551699540/5142574618120153"
    }
    return {
      ...toRefs(state),
      onLoad,
      playVideo,
    };
  },
};
</script>

<style lang="less" scoped>
@import "../../../common/style/mixin";
.info {
  &-item {
    border: 1px solid #dcdcdc;
    padding: 10px;
    margin: 14px;
    border-radius: 20px;
    &-box {
      font-size: 18px;
    }
  }
}

.video-jiangjie {
  font-size: 18px;
  text-decoration: underline;
  text-align: right;
  color: #ff6865;
}
</style>
